<template>
  <div>
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header">
            <h2>
              서비스가입신청
            </h2>
            <!-- 신규 or 기존 -->
            <!-- <span class="dynamic-data-temp info-tag">{{
              openMarketInfo.registrationTypeName
            }}</span> -->
          </div>
          <div class="section-body">
            <ul class="notice-text-list">
              <li class="">
                <strong>LG U<sup>+</sup></strong>는 서비스 가입과 번호이동 처리를 위해 가입자 또는 번호이동 명의자의 정보를 아래와 같이 수집, 이용, 활용하며 
                <strong>LG U<sup>+</sup></strong> 개인정보처리방침에 의해 철저히 관리됩니다.<br/>
                <strong>LG U<sup>+</sup></strong>는 고객님의 개인정보보호를 위하여 최선을 다할 것을 약속 드립니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>이용약관</h3>
            </div>
            <div class="section-body">
              <div
                id="checkbox-container-agreement-all"
                class="input-container"
              >
                <input
                  @change="checkAll"
                  type="checkbox"
                  id="agreement-all"
                  value="agreement-all"
                  class="input-checkbox input-text"
                  title="이용약관 전체동의"
                />
                <label for="agreement-all" class="input-label">전체동의</label>
              </div>

              <!-- 필수약관 -->
              <dl class="field-group">
                <dt class="field-label">
                  <label
                    >이용약관 동의 <em class="primary-text">(필수)</em></label
                  >
                </dt>
                <dd class="field-control">
                  <ul>
                    <li
                      class="accordion type-01"
                      v-for="termCondition in this.reqTermConditionList"
                      v-bind:key="termCondition.svcToaId"
                    >
                      <div
                        :id="'accordion-required-' + termCondition.svcToaId"
                        class="accordion-title"
                        role="heading"
                      >
                        <div
                          :id="'checkbox-container-' + termCondition.svcToaId"
                          class="input-container"
                        >
                          <input
                            :id="'accordion-checkbox-' + termCondition.svcToaId"
                            type="checkbox"
                            :name="termCondition.svcToaId"
                            @click="clickedReqAgreement"
                            class="input-checkbox input-text"
                            v-model="
                              checkedRequiredTermsStatus[termCondition.svcToaId]
                            "
                            ref="checkedRequiredTermsStatus"
                          />
                          <label
                            class="input-label"
                            :id="'accordion-label-' + termCondition.svcToaId" 
                            :for="
                              'accordion-checkbox-' + termCondition.svcToaId
                            "
                            >{{ termCondition.svcToaNm }}</label
                          >
                        </div>
                        <button
                          class="fold-button"
                          @click="showHideAccordion(termCondition.svcToaId)"
                          title="자세히보기"
                          tabindex="0"
                          :area-controls="
                            'accordion-' + termCondition.svcToaId + '-detail'
                          "
                          :id="termCondition.svcToaId + '-show'"
                        ></button>
                      </div>

                      <div
                        :id="'accordion-' + termCondition.svcToaId + '-detail'"
                        class="accordion-detail"
                        tabindex="0"
                        :aria-labelledby="termCondition.svcToaId + '-show'"
                        role="region"
                      >
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId ===
                              'requiredForConciergeDeviceOnlyOneInformation'
                          "
                          v-html="requiredHtmlCntn1"
                        />
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId === 'requiredForPersonalInformation'
                          "
                          v-html="requiredForPersonalInformation"
                        />
                         <!-- ST 이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가-->
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId ===
                              'requiredForPersonalLocationInformation'
                          "
                          v-html="requiredHtmlCntn2"
                        />
                         <!-- ED 이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가-->
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId === 'requiredForServiceProviding'
                          "
                          v-html="requiredHtmlCntn3"
                        />
                         <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId === 'requiredForCreditInformation'
                          "
                          v-html="requiredHtmlCntn4"
                        />
                      </div>
                    </li>
                  </ul>
                </dd>
              </dl>

              <!-- 선택약관 -->
              <dl class="field-group">
                <dt class="field-label">
                  <label>이용약관 동의 (선택)</label>
                </dt>
                <dd class="field-control">
                  <ul>
                    <li
                      class="accordion type-01"
                      v-for="termCondition in this.optTermConditionList"
                      v-bind:key="termCondition.svcToaId"
                    >
                      <div
                        :id="'accordion-required-' + termCondition.svcToaId"
                        class="accordion-title"
                        role="heading"
                      >
                        <div
                          :id="'checkbox-container-' + termCondition.svcToaId"
                          class="input-container"
                        >
                          <input
                            :id="'accordion-checkbox-' + termCondition.svcToaId"
                            type="checkbox"
                            :name="termCondition.svcToaId"
                            @click="clickedOptAgreement"
                            class="input-checkbox input-text"
                          />
                          <label
                            class="input-label"
                            :id="'accordion-label-' + termCondition.svcToaId" 
                            :for="
                              'accordion-checkbox-' + termCondition.svcToaId
                            "
                            >{{ termCondition.svcToaNm }}</label
                          >
                        </div>
                        <button
                          class="fold-button"
                          @click="showHideAccordion(termCondition.svcToaId)"
                          title="자세히보기"
                          tabindex="0"
                          :area-controls="
                            'accordion-' + termCondition.svcToaId + '-detail'
                          "
                          :id="termCondition.svcToaId + '-show'"
                        ></button>
                      </div>

                      <div
                        :id="'accordion-' + termCondition.svcToaId + '-detail'"
                        class="accordion-detail"
                        tabindex="0"
                        :aria-labelledby="termCondition.svcToaId + '-show'"
                        role="region"
                      >
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId === 'optionalMarketingOffer'
                          "
                          v-html="optionalHtmlCntn1"
                        />
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId ===
                              'optionalMarketingOfferPersonal'
                          "
                          v-html="optionalHtmlCntn2"
                        />
                        <!-- 개인정보 정합성 PJT 조치 사항적용 2025.06.30
                        <div
                          :id="'accordion-html-' + termCondition.svcToaId"
                          v-if="
                            termCondition.svcToaId ===
                              'optionalMarketingOfferPersonalTrst'
                          "
                          v-html="optionalMarketingOfferPersonalTrst"
                        />                        
                         <! -- 처리위탁 유통점 추가 시작 C20210407_06398_4406398 -- >
                           <br/>
                           <span  v-if="termCondition.svcToaId ==='optionalMarketingOfferPersonalTrst'" class="dynamic-data-temp">처리위탁 유통점 : {{ $store.state.appfData.dlrNm }}</span>
                         <! -- 처리위탁 유통점 추가 끝 C20210407_06398_4406398 -- >
                      </div>
                      -->
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  M-Safer 제공
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        신규가입 시 명의도용 방지를 위하여 고객님의 정보를 한국정보통신진흥협회 및 타통신사업자에 제공하여 기존의 사용 중인 전화로 개통사실을 통보합니다.
                      </li>
                    </ul>
                  </div>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  개인정보침해 신고
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        이메일 : webmaster@lguplus.co.kr / privacy@lguplus.co.kr, 전화번호 : 모바일(휴대폰+114, 인터넷/070/TV(101), 기업(1544-0001)  개인정보보호책임자 : 정보보안센터장
                      </li>
                    </ul>
                  </div>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  기 타
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        위 내용은 원활한 서비스 가입, 이용상 필요하므로 미동의 시 서비스 가입, 이용에 제약이 있을 수 있으며, 고객님이 원치 않으실 경우 정보가 제공되지 않습니다.
                      </li>
                      <li class="notice-text">
                        개인정보 처리위탁, 제공 현황 및 변동사항은 홈페이지(www.lguplus.com)상 개인정보처리방침에 공개하여 고지합니다.
                      </li>
                    </ul>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
          <div class="step-bottom-area input-wrap">
            <button
              class="primary-button mw100 pc-float-right"
              @click="save"
            >
              서비스 신청하기
            </button>
          </div>
        </div>
      </div>
    <v-dialog />
  </div>
</template>

<script>
  import { sendHomeIoTAppfToUCube } from '@/api/onsaleHome'
  import { getHmCupsifItemList } from '@/api/onsaleHome'
  import { routerHome } from '@/router/routerHome'
export default {
  name: 'OnsaleHomeStep2',

  data() {
    return {
      appfData:{},
      checkedRequiredTermsStatus:{},
      checkedOptionTermsStatus: {},
      
      reqTermConditionList: [
        {
          req: true,
          svcToaId: 'requiredForConciergeDeviceOnlyOneInformation',
          svcToaNm: '고유식별 정보 수집, 이용 동의 (필수)',
          svcToaCntn: '컨시어지 디바이스 용 약관동의 ',
          svcToaFileNm: '~/html/appl/agree1_home.html'
        },
        {
          req: true,
          svcToaId: 'requiredForPersonalInformation',
          svcToaNm: '개인정보 수집 이용동의 (필수)',
          svcToaCntn: '개인정보 수집 이용동의 (필수) - 내용',
          svcToaFileNm: '~/html/appl/agree2_home.html'
        },
        {
          req: true,
          svcToaId: 'requiredForPersonalLocationInformation',
          svcToaNm: '개인위치 정보 수집,이용동의 (필수)',
          svcToaCntn: '개인위치 정보 수집,이용동의 (필수) - 내용',
          svcToaFileNm: '~/html/appl/agree_personal_location.html'
        },
        {
          req: true,
          svcToaId: 'requiredForServiceProviding',
          svcToaNm: '개인정보 제3자 제공 동의(필수)',
          svcToaCntn: '개인정보 제3자 제공 동의(필수)- 내용',
          svcToaFileNm: '~/html/appl/agree7_home.html'
        },
        {
          req: true,
          svcToaId: 'requiredForCreditInformation',
          svcToaNm: '개인신용정보 조회 동의(필수)',
          svcToaCntn: '개인신용정보 조회 동의(필수) - 내용',
          svcToaFileNm: '~/html/appl/agree5_hmcredit.html'
        },
      ],

      optTermConditionList: [
        {
          req: false,
          svcToaId: 'optionalMarketingOffer',
          //svcToaNm: '고객혜택정보/광고정보 제공을 위한 동의 (선택)',
          //svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 동의 (선택) ',
          svcToaNm: '고객 혜택정보 제공을 위한 정보 수집 ·이용 동의',
          svcToaCntn: '고객 혜택정보 제공을 위한 정보 수집 ·이용 동의',
          svcToaFileNm: '~/html/appl/agree8_home.html'
        },
        // 마케팅 활용동의에 대하여 선택적으로 동의를 받고 있으나. SMS, 이메일, 앱푸시 등 분리하여 동의를 받지 않고 있음
        {
          req: false,
          svcToaId: 'optionalMarketingOfferPersonal',
          //svcToaNm: '고객혜택정보/광고 정보제공을 위한 개인정보처리위탁 동의 (선택)',
          //svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 동의 (선택)',
          svcToaNm: '혜택정보 · 광고 수신 동의',
          svcToaCntn: '혜택정보 · 광고 수신 동의',
          svcToaFileNm: '~/html/appl/agree10_home.html'
        },
        /*{//개인정보 정합성 PJT 조치 사항적용 2025.06.30
          req: false,
          svcToaId: 'optionalMarketingOfferPersonalTrst',
          svcToaNm: '고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내',
          svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내',
          svcToaFileNm: '~/html/appl/agree16.html'
        },  */   
      ],

      requiredHtmlCntn1: '',
      requiredHtmlCntn2: '',
      requiredHtmlCntn3: '',
      requiredHtmlCntn4: '',
      optionalHtmlCntn1: '',
      optionalHtmlCntn2: '',
      cupsifItemList: [],
      agrList: []
    }
  },

  computed:{
    requiredForConciergeDeviceOnlyOneInformation() {
      return require('html-loader!~/html/appl/agree1_home.html')
    },
    requiredForPersonalInformation() {
      let fileName = 'agree2_home.html'
      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForPersonalLocationInformation(){
      //이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가
      return require('html-loader!~/html/appl/agree_personal_location.html')
    },
    requiredForServiceProviding() {
      return require('html-loader!~/html/appl/agree7_home.html')
    },
    requiredForCreditInformation() {
      let fileName = 'agree5_hmcredit.html'
      return require('html-loader!~/html/appl/' + fileName)
    },
    optionalMarketingOffer() {
      //  고객 혜택정보/광고 정보 제공을 위한 동의(선택동의) =>  24.05.02 고객 혜택정보 제공을 위한 정보 수집 ·이용 동의
      return require('html-loader!~/html/appl/agree8_home.html')
    },
    optionalMarketingOfferPersonal() {
      //  고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 동의(선택동의) => 24.05.02 혜택정보 · 광고 수신 동의
      return require('html-loader!~/html/appl/agree10_home.html')
    }
   /* optionalMarketingOfferPersonalTrst() {////개인정보 정합성 PJT 조치 사항적용 2025.06.30
      //  24.05.02 고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내
      return require('html-loader!~/html/appl/agree16.html')
    }*/
  },

  mounted() {
    this.requiredHtmlCntn1 = this.requiredForConciergeDeviceOnlyOneInformation
    this.requiredHtmlCntn2 = this.requiredForPersonalLocationInformation
    this.requiredHtmlCntn3 = this.requiredForServiceProviding
    this.requiredHtmlCntn4 = this.requiredForCreditInformation
    this.optionalHtmlCntn1 = this.optionalMarketingOffer
    this.optionalHtmlCntn2 = this.optionalMarketingOfferPersonal

    for(let i = 0; i < this.reqTermConditionList.length ; i++ ){
      this.checkedRequiredTermsStatus[this.reqTermConditionList[i].svcToaId] = false
    }
    for(let i = 0; i < this.optTermConditionList.length ; i++ ){
      this.checkedOptionTermsStatus[this.optTermConditionList[i].svcToaId] = false
    }

    if (this.$store.state.appfData.custNm === '') {
      this.$router.replace({
        name: 'Error',
        props: true,
        params: {
          message:
                  '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
          type: 'access'
        }
      })
      return
    }

    this.setCupsifItem()
  },

  methods: {
    
    //[ST][CSR ID: RITM2071346] PrivacyCenter 통합관리시스템 구축 2차 온라인가입지원 프로젝트
    setCupsifItem(){
      getHmCupsifItemList()
        .then(res => {
          let itemList = res.data.dsOutput
          this.cupsifItemList = res.data.dsOutput
          
          for(let i = 0; i < itemList.length; i++) {
            if(itemList[i].cupsifItemAgrKdCd === 'M') {   //필수
              for(let j = 0; j < this.reqTermConditionList.length; j++) {
                  
                if(itemList[i].cupsifItemKdCd === 'A0004' && this.reqTermConditionList[j].svcToaId === 'requiredForConciergeDeviceOnlyOneInformation') {  //고유식별 정보 수집.이용 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  const labelId = document.getElementById('accordion-label-requiredForConciergeDeviceOnlyOneInformation')
                  const htmlId = document.getElementById('accordion-html-requiredForConciergeDeviceOnlyOneInformation')

                  if(labelId) {
                    labelId.innerText = itemList[i].cupsifItemNm + ' (필수)'
                  }
                  if(htmlId) {
                    let cupsifItemCntn = ''
                    if(itemList[i].cupsifItemCntnUseYn === 'Y') {
                      cupsifItemCntn = this.applyHtml(itemList[i].cupsifItemCntn)
                    } else {
                      cupsifItemCntn = this.applyHtml(itemList[i].onetCupsifItemCntn)
                    }

                    if(cupsifItemCntn.trim() !== '') {
                      this.requiredHtmlCntn1 = cupsifItemCntn
                    }
                  }

                } else if(itemList[i].cupsifItemKdCd === 'A0006' && this.reqTermConditionList[j].svcToaId === 'requiredForPersonalLocationInformation'){  //개인정보.개인위치정보 수집.이용 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  const labelId = document.getElementById('accordion-label-requiredForPersonalLocationInformation')
                  const htmlId = document.getElementById('accordion-html-requiredForPersonalLocationInformation')

                  if(labelId) {
                    labelId.innerText = itemList[i].cupsifItemNm + ' (필수)'
                  }
                  if(htmlId) {
                    let cupsifItemCntn = ''
                    if(itemList[i].cupsifItemCntnUseYn === 'Y') {
                      cupsifItemCntn = this.applyHtml(itemList[i].cupsifItemCntn)
                    } else {
                      cupsifItemCntn = this.applyHtml(itemList[i].onetCupsifItemCntn)
                    }

                    if(cupsifItemCntn.trim() !== '') {
                      this.requiredHtmlCntn2 = cupsifItemCntn
                    }
                  }
                  
                } else if(itemList[i].cupsifItemKdCd === 'A0035' && this.reqTermConditionList[j].svcToaId === 'requiredForServiceProviding'){             //개인정보 제3자제공 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  const labelId = document.getElementById('accordion-label-requiredForServiceProviding')
                  const htmlId = document.getElementById('accordion-html-requiredForServiceProviding')

                  if(labelId) {
                    labelId.innerText = itemList[i].cupsifItemNm + ' (필수)'
                  }
                  if(htmlId) {
                    let cupsifItemCntn = ''
                    if(itemList[i].cupsifItemCntnUseYn === 'Y') {
                      cupsifItemCntn = this.applyHtml(itemList[i].cupsifItemCntn)
                    } else {
                      cupsifItemCntn = this.applyHtml(itemList[i].onetCupsifItemCntn)
                    }

                    if(cupsifItemCntn.trim() !== '') {
                      this.requiredHtmlCntn3 = cupsifItemCntn
                    }
                  }
                  
                } else if(itemList[i].cupsifItemKdCd === 'A0036' && this.reqTermConditionList[j].svcToaId === 'requiredForCreditInformation'){             //개인신용정보 조회 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  const labelId = document.getElementById('accordion-label-requiredForCreditInformation')
                  const htmlId = document.getElementById('accordion-html-requiredForCreditInformation')

                  if(labelId) {
                    labelId.innerText = itemList[i].cupsifItemNm + ' (필수)'
                  }
                  if(htmlId) {
                    let cupsifItemCntn = ''
                    if(itemList[i].cupsifItemCntnUseYn === 'Y') {
                      cupsifItemCntn = this.applyHtml(itemList[i].cupsifItemCntn)
                    } else {
                      cupsifItemCntn = this.applyHtml(itemList[i].onetCupsifItemCntn)
                    }

                    if(cupsifItemCntn.trim() !== '') {
                      this.requiredHtmlCntn4 = cupsifItemCntn
                    }
                  }
                  
                }
              }
            }else {    //선택
              for(let j = 0; j < this.optTermConditionList.length; j++) {
                
                if(itemList[i].cupsifItemKdCd === 'I0001' && this.optTermConditionList[j].svcToaId === 'optionalMarketingOffer') {            //고객 혜택정보 제공을 위한 정보 수집 · 이용 동의
                  
                  this.optTermConditionList[j].req = false
                  this.optTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm
                  this.optTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm
                  const labelId = document.getElementById('accordion-label-optionalMarketingOffer')
                  const htmlId = document.getElementById('accordion-html-optionalMarketingOffer')

                  if(labelId) {
                    labelId.innerText = itemList[i].cupsifItemNm
                  }
                  if(htmlId) {
                    let cupsifItemCntn = ''
                    if(itemList[i].cupsifItemCntnUseYn === 'Y') {
                      cupsifItemCntn = this.applyHtml(itemList[i].cupsifItemCntn)
                    } else {
                      cupsifItemCntn = this.applyHtml(itemList[i].onetCupsifItemCntn)
                    }

                    if(cupsifItemCntn.trim() !== '') {
                      this.optionalHtmlCntn1 = cupsifItemCntn
                    }
                  }

                } else if(itemList[i].cupsifItemKdCd === 'I0002' && this.optTermConditionList[j].svcToaId === 'optionalMarketingOfferPersonal'){  //혜택정보 · 광고 수신 동의

                  this.optTermConditionList[j].req = false
                  this.optTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm
                  this.optTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm
                  const labelId = document.getElementById('accordion-label-optionalMarketingOfferPersonal')
                  const htmlId = document.getElementById('accordion-html-optionalMarketingOfferPersonal')

                  if(labelId) {
                    labelId.innerText = itemList[i].cupsifItemNm
                  }
                  if(htmlId) {
                    let cupsifItemCntn = ''
                    if(itemList[i].cupsifItemCntnUseYn === 'Y') {
                      cupsifItemCntn = this.applyHtml(itemList[i].cupsifItemCntn)
                    } else {
                      cupsifItemCntn = this.applyHtml(itemList[i].onetCupsifItemCntn)
                    }

                    if(cupsifItemCntn.trim() !== '') {
                      this.optionalHtmlCntn2 = cupsifItemCntn
                    }
                  }
                }
              }
            }
          }
        })
        .catch(e => {
          this.openAlert('동의항목 설정 오류')
        })
    },

    applyHtml(html) {
      const textarea = document.createElement('textarea')
      textarea.innerHTML = html
      return textarea.value
    }, 

    //[ED][CSR ID: RITM2071346] PrivacyCenter 통합관리시스템 구축 2차 온라인가입지원 프로젝트

    save(){
      if(!this.beforeSave()) return
      sendHomeIoTAppfToUCube(this.$store.state.appfData)
        .then(res => {
          let resultCd = res.data.dsRsltInfo.rsltCd
          let resultMsg = res.data.dsRsltInfo.rsltMsg
          if (resultCd === 'SUCCESS') {
            alert(resultMsg)
            this.$router.push({ name: 'OnsaleHome' })
          } else {
            // this.openAlert(resultCd, resultMsg)
            this.openAlert('오류', resultMsg)
          }
        })
        .catch(e => {
          this.openAlert('오류', '신청 중 오류가 발생하였습니다.')
        })
    },

    beforeSave(){

      for(let i = 0; i < this.reqTermConditionList.length ; i++ ){
        if(!this.checkedRequiredTermsStatus[this.reqTermConditionList[i].svcToaId]){
          this.openAlert('온라인 가입신청 안내', this.reqTermConditionList[i].svcToaNm + ' 동의 사항을 확인해주세요.')
          return false
        }
      }
      //최종 저장시 인증한 정보와 신청서 정보가 일치하는지 확인하는 validation --> TODO (step2->step3)에도 추가
//      if(this.$store.state.appfData.custNm !== this.$store.state.appfData.moct_name
//      || this.$store.state.appfData.custrnmBday.substr(0,6) !== this.$store.state.appfData.moct_birthDay){
//        this.openAlert('온라인 가입신청 안내', '가입자 정보와 인증 정보가 일치하지 않습니다. 확인 후 재신청바랍니다.')
//        return false
//      }

      //선택약관 동의
      this.$store.state.appfData.chk_Y_2 = (this.checkedOptionTermsStatus[this.optTermConditionList[0].svcToaId]) ? 'Y' : 'N'
      this.$store.state.appfData.chk_Y_4 = (this.checkedOptionTermsStatus[this.optTermConditionList[1].svcToaId]) ? 'Y' : 'N'
      // this.$store.commit('saveTpsInfo', this.appfData)

      //[ST][CSR ID: RITM2071346] PrivacyCenter 통합관리시스템 구축 2차 온라인가입지원 프로젝트
      // 선택동의항목 중 종속 약관 체크
      if(this.$store.state.appfData.chk_Y_2 === 'N' && this.$store.state.appfData.chk_Y_4 == 'Y') {
        this.openAlert('온라인 가입신청 안내', '고객 혜택정보 제공을 위한 정보 수집 ·이용 미동의인 경우 혜택정보 · 광고 수신 동의할 수 없습니다.')
        return false
      }

      for(let i = 0; i < this.cupsifItemList.length; i++) {

        let sCupsifItemId = this.cupsifItemList[i].cupsifItemId
        let sCupsifItemVerNo = this.cupsifItemList[i].cupsifItemVerNo
        let sCupsifItemNm = this.cupsifItemList[i].cupsifItemNm
        let sCupsifItemKdCd = this.cupsifItemList[i].cupsifItemKdCd
        let sCupsifItemSortOrd = this.cupsifItemList[i].cupsifItemSortOrd
        let sCupsifYn = ''

        if(sCupsifItemKdCd === 'A0004' || 
           sCupsifItemKdCd === 'A0006' ||
           sCupsifItemKdCd === 'A0035' || 
           sCupsifItemKdCd === 'A0036') {

          sCupsifYn = 'Y'   //필수 동의 'Y'

        } else if(sCupsifItemKdCd === 'I0001') {

          sCupsifYn = this.$store.state.appfData.chk_Y_2    //고객 혜택정보 제공을 위한 정보 수집 · 이용 동의

        } else if(sCupsifItemKdCd === 'I0002') {

          sCupsifYn = this.$store.state.appfData.chk_Y_4    //혜택정보 · 광고 수신 동의

        }
        
        this.agrList.push( { cupsifItemId: sCupsifItemId, cupsifItemVerNo: sCupsifItemVerNo, cupsifItemNm: sCupsifItemNm, cupsifItemKdCd: sCupsifItemKdCd, cupsifItemSortOrd: sCupsifItemSortOrd, cupsifYn: sCupsifYn } )
      }

      this.$store.state.appfData.homeTPSActivationAgrList = this.agrList
      //[ED][CSR ID: RITM2071346] PrivacyCenter 통합관리시스템 구축 2차 온라인가입지원 프로젝트

      return true
    },

    /** 
     * Function    : showHideAccordion
     * Description : 약관 accordion
     **/
    showHideAccordion(id) {
      const panel = document.getElementById('accordion-' + id + '-detail')
      if (panel.style.maxHeight)
        (panel.style.maxHeight = null),
          (panel.style.height = null),
          (panel.style.padding = '0 12px'),
          (panel.style.overflow = 'hidden'),
          (panel.style.visibility = 'hidden'),
          panel.previousElementSibling.classList.toggle('active')
      else
        (panel.style.maxHeight = '220px'),
          (panel.style.height = 'auto'),
          (panel.style.padding = '12px'),
          (panel.style.overflow = 'auto'),
          (panel.style.visibility = 'visible'),
          panel.previousElementSibling.classList.toggle('active')
    },

     /** 
     * Function    : clickedReqAgreement
     * Description : 필수약관 동의
     **/
    clickedReqAgreement(event) {
      this.checkedRequiredTermsStatus[event.target.name] = event.target.checked
    },

    /** 
     * Function    : clickedOptAgreement
     * Description : 선택약관 동의
     **/
    clickedOptAgreement(event) {
      this.checkedOptionTermsStatus[event.target.name] = event.target.checked
    },

    /** 
     * Function    : checkAll
     * Description : 약관 전체동의
     **/
    checkAll(checkAllEvent) {
      this.reqTermConditionList.forEach(termCondition => {
        const elementId = 'accordion-checkbox-' + termCondition.svcToaId

        const htmlElement = document.getElementById(elementId)
        if (htmlElement != null) {
          htmlElement.checked = checkAllEvent.target.checked

          const simulatedEvent = {
            target: {
              name: termCondition.svcToaId,
              checked: checkAllEvent.target.checked
            }
          }

          this.clickedReqAgreement(simulatedEvent)
        }
      })

      this.optTermConditionList.forEach(termCondition => {
        const elementId = 'accordion-checkbox-' + termCondition.svcToaId

        const htmlElement = document.getElementById(elementId)
        if (htmlElement != null) {
          htmlElement.checked = checkAllEvent.target.checked

          const simulatedEvent = {
            target: {
              name: termCondition.svcToaId,
              checked: checkAllEvent.target.checked
            }
          }

          this.clickedOptAgreement(simulatedEvent)
        }
      })
    },
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              if (ref) {
                ref.focus()
              }
            }
          }
        ]
      })
    },
  }
}
</script>

<style scoped>

</style>
